import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DashboardService } from './dashboard.service';
import { BaseChartDirective } from 'ng2-charts';

import {
  //ArcElement,
  //BarController,
  //BarElement,
  CategoryScale,
  Chart,
  ChartConfiguration,
  //DoughnutController,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  //PieController,
  PointElement,
  //PolarAreaController,
  //RadarController,
  //RadialLinearScale,
  Title,
  Tooltip,
  Filler
} from 'chart.js'
import { AuthService } from '../auth/auth.service';

Chart.register(
  CategoryScale,
  LinearScale,
  //BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  LineController,
  PointElement,
  LineElement,
  //BarController,
  //DoughnutController,
  //ArcElement,
  //PolarAreaController,
  //RadialLinearScale,
  //PieController,
  //RadarController
)

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [TranslateModule, CommonModule, BaseChartDirective],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  userId:any;
  devices: any[] = []; // Array to store device records
  operations: any[] = []; // Array to store operation records
  selectedDeviceId: string | null = null; // Store the selected device ID
  selectedOperationId: string | null = null; // Store the selected operation ID
  graphData: any = {}; // Store the graph data

  chartDatasets: ChartConfiguration<'line'>['data']['datasets'] = [];
  chartOptions: ChartConfiguration<'line'>['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
  };

  constructor(
    private dashboardService: DashboardService,
    private authService: AuthService,
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    this.userId = this.authService.getLoggedInUserId();
    this.fetchUserDeviceIds();

    //init chart
    this.updateChartData();
  }

  fetchUserDeviceIds(): void {
    const postdata = {
      "user_id": this.userId,
    };
    this.dashboardService.getUserDeviceIds(postdata).subscribe({
      next: (response: any) => {
        if (response.success && response.record) {
          this.devices = response.record; // Store the record array
        } else {
          //console.error('Invalid API response:', response);
          this.devices = [];
        }
      },
      error: (error) => {
        //console.error('Error fetching device IDs:', error);
        this.devices = [];
      }
    });
  }

  onDeviceChange(deviceId: string | null): void {
    this.selectedDeviceId = deviceId;
    if (deviceId) {
      const payload = {
        user_id: this.userId,
        uid: deviceId,
      };
      this.dashboardService.getOperationList(payload).subscribe({
        next: (response: any) => {
          if (response.success && response.record) {
            this.operations = response.record; // Store the operation records
          } else {
            //console.error('Invalid API response:', response);
            this.operations = []; // Reset operations if no records are found
          }
        },
        error: (error) => {
          //console.error('Error fetching operation list:', error);
          this.operations = [];
        }
      });

      // Clear graph data
      this.graphData = {};

    } else {
      this.operations = []; // Clear operations if no device is selected
    }
  }

  onOperationChange(operationId: string | null): void {
    this.selectedOperationId = operationId;
    if (operationId) {
      const payload = {
        user_id: this.userId,
        uid: this.selectedDeviceId,
        opp_id: operationId,
      };
      this.dashboardService.getViewGraphData(payload).subscribe({
        next: (response: any) => {
          if (response.success && response.data) {
            this.graphData = response.data; // Store the graph data

            // Update chart datasets
            this.updateChartData();
          } else {
            //console.error('Invalid API response:', response);
            this.graphData = {};
            this.chartDatasets = [];
          }
        },
        error: (error) => {
          //console.error('Error fetching graph data:', error);
          this.graphData = {};
          this.chartDatasets = [];
        }
      });
    } else {
      this.graphData = {}; // Clear graph data if no operation is selected
      this.chartDatasets = [];
    }
  }

  updateChartData(): void {
    this.chartDatasets = [
      {
        data: this.graphData.vibration,
        label: this.translateService.instant('Vibration'),
        borderColor: 'rgb(246, 6, 6)',
        backgroundColor: 'rgba(224, 15, 15, 0.2)',
        fill: true,
      },
      {
        data: this.graphData.rotation,
        label: this.translateService.instant('Rotation'),
        borderColor: 'rgb(8, 238, 35)',
        backgroundColor: 'rgba(11, 237, 64, 0.2)',
        fill: true,
      }
    ];
  }

}
